"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentCardPreview = void 0;
var Utilities_1 = require("../../Utilities");
var DocumentCardPreview_base_1 = require("./DocumentCardPreview.base");
var DocumentCardPreview_styles_1 = require("./DocumentCardPreview.styles");
exports.DocumentCardPreview = Utilities_1.styled(DocumentCardPreview_base_1.DocumentCardPreviewBase, DocumentCardPreview_styles_1.getStyles, undefined, { scope: 'DocumentCardPreview' });
//# sourceMappingURL=DocumentCardPreview.js.map